import axios from "axios";
import { getTicketInfoApi } from "./getTicketInfoApi";

export const fetchTicketInfo = async (ticketId, peerIp) => {
  const { apiUrl } = getTicketInfoApi(ticketId);
  const response = await axios.get(apiUrl, {
    headers: {
      user_ip: peerIp
    },
  });

  return response.data;
};
